import api from 'api';

export const MENU_ITEM_COST_RECIPES_ASYNC_ACTION_START = 'MENU_ITEM_COST_RECIPES_ASYNC_ACTION_START';
export const MENU_ITEM_COST_RECIPES_ASYNC_ACTION_ERROR = 'MENU_ITEM_COST_RECIPES_ASYNC_ACTION_ERROR';
export const MENU_ITEM_COST_RECIPES_ASYNC_UPDATE_SUCCESS = 'MENU_ITEM_COST_RECIPES_ASYNC_UPDATE_SUCCESS';
export const MENU_ITEM_COST_RECIPES_UPDATE_SEARCH = 'MENU_ITEM_COST_RECIPES_UPDATE_SEARCH';
export const DEBOUNCE_MENU_ITEM_COST_RECIPES = 'DEBOUNCE_MENU_ITEM_COST_RECIPES';
export const MENU_ITEM_COST_RECIPES_RESET_STATE = 'MENU_ITEM_COST_RECIPES_RESET_STATE';

function menuItemCostRecipesAsyncActionStart() {
  return {
    type: MENU_ITEM_COST_RECIPES_ASYNC_ACTION_START,
  };
}

function menuItemCostRecipesAsyncActionError(error) {
  return {
    type: MENU_ITEM_COST_RECIPES_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuItemCostRecipesAsyncUpdateSuccess(data) {
  return {
    type: MENU_ITEM_COST_RECIPES_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

export function updateMenuItemRecipeFilter(data) {
  return {
    type: MENU_ITEM_COST_RECIPES_UPDATE_SEARCH,
    data,
  };
}

export function resetMenuItemCostRecipesState() {
  return {
    type: MENU_ITEM_COST_RECIPES_RESET_STATE,
  };
}

export function getMenuItemCostRecipes(brandId, menuItemId, recipeNameKeyword, isFromSysco, isVisible) {
  const thunk = (dispatch, getState) => {
    
    dispatch(menuItemCostRecipesAsyncActionStart());
    return api.request(
      `menuItemCost/recipeList?brandId=${ brandId }&menuItemId=${ menuItemId }&recipeNameKeyword=${ recipeNameKeyword }&isFromSysco=${ isFromSysco }&visible=${isVisible}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(menuItemCostRecipesAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemCostRecipesAsyncActionError('Unable to get Menu Item Recipe Costs'));
      throw (err);
    });
  };
  thunk.meta = {
    debounce: {
      time: 20,
      key: DEBOUNCE_MENU_ITEM_COST_RECIPES,
    },
  };
  return thunk;
}
